export function isMoreThanOneYearBeforeToday(date) {
    const currentDate = new Date();
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(currentDate.getFullYear() - 1);

     
    return new Date(date) < oneYearAgo;
}
